import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useMutation } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import REMOVE_FROM_SHOPPING_LIST from '../operations/mutations/remove-from-shopping-list.js';

const useRemoveFromShoppinglist = ({ onError , onCompleted  })=>{
    const { locale  } = useIntl();
    const [hasError, setHasError] = React.useState(false);
    const [mutation, { data: data1 , loading , error  }] = useMutation(REMOVE_FROM_SHOPPING_LIST, {
        onError () {
            onError === null || onError === void 0 ? void 0 : onError();
        },
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        refetchQueries: [
            'GetShoppingListCount',
            'GetMyWishlistId',
            'GetMyWishlist'
        ]
    });
    const handleOnCompleted = React.useCallback((data)=>{
        if (data.removeFromShoppinglist.__typename === 'RemoveFromShoppinglistFailureResponse') {
            onError === null || onError === void 0 ? void 0 : onError();
        }
        onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(data);
    }, [
        onCompleted,
        onError
    ]);
    const removeFromShoppinglist = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(productSkus, shoppinglistId) {
            try {
                if (shoppinglistId) {
                    const { data  } = yield mutation({
                        variables: {
                            input: {
                                productSkus,
                                shoppinglistId
                            }
                        }
                    });
                    if (data) {
                        handleOnCompleted(data);
                    }
                }
            } catch (e) {
                setHasError(true);
                console.error('Error while removing a wishlist item from the shopping list', e);
            }
        });
        return function(productSkus, shoppinglistId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        handleOnCompleted,
        mutation
    ]);
    var ref, ref1;
    return {
        removeFromShoppinglist,
        loading,
        error: (ref1 = (ref = error !== null && error !== void 0 ? error : hasError) !== null && ref !== void 0 ? ref : (data1 === null || data1 === void 0 ? void 0 : data1.removeFromShoppinglist.__typename) === 'RemoveFromShoppinglistFailureResponse') !== null && ref1 !== void 0 ? ref1 : null
    };
};

export { useRemoveFromShoppinglist };
//# sourceMappingURL=use-remove-from-shopping-list.js.map
